import {Box, Center, Heading, Image, Stack, Text, useBreakpointValue} from '@chakra-ui/react';
import React from 'react';
import bull from 'assets/images/whiteBull.png'
import darkbg from 'assets/images/bg1.webp'
import sgBg from 'assets/images/SGRegisterBg.jpg'
import newFoxLong from 'assets/images/newFoxLong.jpg';
import trust from 'assets/images/Trustpilot Micro.svg'
import trustWhite from 'assets/images/TrustpilotMicroWhite.svg'
import FoxLog from "assets/images/newFoxLong.jpg";
import { useTranslation } from 'react-i18next';
import LoginBg from "assets/images/login_bg.jpg"

const GuestBanner = (props) => {
    const { isSGUser } = props
    const {t} = useTranslation('app')
    return (
		<Box
			// bg="rgb(4,5,1)"
			// flex={1}
			// h="100vh"
			// backgroundImage={isSGUser ? sgBg : darkbg}
			// backgroundPosition={isSGUser ? "0 -40px" : "top left"}
			// backgroundRepeat={"no-repeat"}
			// backgroundSize={isSGUser ? "100%" : "cover"}
			flex={1}
			h="100vh"
			w="50vw"
			bgImage={`url(${LoginBg})`}
			bgSize="cover"
			bgRepeat="no-repeat"
			bgPosition="center"
			pos={'relative'}
		>
			{/*<Image*/}
			{/*	src={FoxLog}*/}
			{/*	height={"50px"}*/}
			{/*	pos={"absolute"}*/}
			{/*	top={2}*/}
			{/*	left={2}*/}
			{/*/>*/}
			<Box
				flex={1}
				h="100vh"
				backgroundImage={isSGUser ? "" : ""}
				backgroundPosition={"bottom right"}
				backgroundRepeat={"no-repeat"}
				backgroundSize={"100%"}
				py={24}
				px={16}
			>
				<Stack
					spacing={4}
					sx={
						isSGUser
							? { justifyContent: "center", alignItems: "center" }
							: {}
					}
				>
					{/* {isSGUser ? (
						<Stack>
							<Heading
								color={"white"}
								fontSize={"80px"}
								textAlign={"center"}
								fontWeight={"700"}
							>
								{t("Trusted")}
							</Heading>
							<Heading
								w={"100%"}
								color={"white"}
								fontSize={"80px"}
								fontWeight={"700"}
							>
								{t("byOurClients")}
							</Heading>
						</Stack>
					) : ( */}
						<Heading
							w={"70%"}
							color={"white"}
							fontSize={"60px"}
							fontWeight={"800"}
						>
							{t("Finance1")}
						</Heading>
					{/* )} */}

					{/* <Image src={trustWhite} width={"450px"} /> */}
				</Stack>
			</Box>
		</Box>
	);
};

export default GuestBanner;
